import { Cross } from '@react-vant/icons';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Skeleton, Steps } from 'react-vant';
import { apiGetH5QueryOrderTrack } from '../api';
import AppBar from '../components/appBar';
import Empty from '../components/empty';
import Page from '../components/page';
import { Order } from '../types';
import { operatorsTypeData } from '../utils/source';
import { copyToClipboard, dictLabel, parseLocationParams } from '../utils/utils';

interface Tracks {
  time?: string;
  context?: string;
  expressName?: string;
  expressNum?: string;
}

export default function LogisticsPage() {
  const location = useLocation();
  const [logisticsData, setLogisticsData] = useState<{ [x: string]: Order | Tracks | null | any }>();
  const [errorTxt, setErrorTxt] = useState();
  // 记录商品列表请求状态
  const [isSkeleton, setisSkeleton] = useState<boolean>(false);

  useEffect(() => {
    let _p = parseLocationParams(location.search) ?? {};
    if (_p.id) {
      getH5QueryOrderTrack(_p.id);
    }
  }, []); // eslint-disable-line

  async function getH5QueryOrderTrack(id: string) {
    setisSkeleton(true);
    try {
      let res = await apiGetH5QueryOrderTrack({ id });
      let data = res.data;
      if (data.code === 200) {
        setLogisticsData(data.data);
      } else {
        setErrorTxt(data.msg ?? '查询失败');
      }
    } catch (error) {
    } finally {
      setisSkeleton(false);
    }
  }

  let order: Order = logisticsData?.order ?? {};
  let tracksList: Tracks[] = logisticsData?.tracks ?? [];
  let express: Tracks = logisticsData?.express;
  let receiverInfo: Order = logisticsData?.receiverInfo ?? {};

  // 请求列表时显示骨架屏
  if (isSkeleton) {
    return (
      <div className="bw-100 hvh-100 pt-10">
        <Skeleton rowHeight={15} row={15} />
      </div>
    );
  }

  if (!!errorTxt) {
    return (
      <Empty tips={errorTxt} tipsClassName="font-size-16 font-widget-500" showBackBtn={false} pic="/pic/no_data.png" />
    );
  }

  return (
    <Page
      className="logistics-page d-flex-c"
      contentClassName="flex-1 h-1 mb-10 overflow-y"
      appBar={<AppBar className="bg-transparent" title="物流轨迹" />}
    >
      <div className="bg-white p-15">
        <div className="d-flex-r ai-center jc-between font-size-16 font-widget-500 pb-5">
          <span>{dictLabel(order?.operatorsType, operatorsTypeData)}通信专营授权店</span>
          <span className="text-color-p">{order?.orderStatusDesc}</span>
        </div>
        <div className="d-flex-r mt-10">
          <img className="w-80 h-80 border-radius-4" src={order?.goodsHeadImg} alt="" />
          <div className="flex-1 ml-15 d-flex-c">
            <div className="flex-1 omit-text-2">{order?.orderName}</div>
            <div className="d-flex-r ai-center jc-between">
              <div>
                <span className="text-color-3">实付金额：</span>
                {Number(order?.payAmount ?? 0).toFixed(2)}
              </div>
              <div className="text-color-6 d-flex-r ai-center">
                <Cross className="mr-3" />1
              </div>
            </div>
          </div>
        </div>
      </div>
      {!!express && (
        <div className="m-10">
          <div className="border-radius-8 bg-white pt-15 pb-10">
            <div className="d-flex-r ai-center jc-between pb-5 pl-10 pr-10">
              <div className="text-color-3">
                <span>{express?.expressName}</span>
                <span className="ml-5">{express?.expressNum}</span>
              </div>
              <div className="d-flex-r ai-center" onClick={() => copyToClipboard(express?.expressNum!)}>
                复制
                <img className="ml-3 w-20" src="/pic/icon_copy.png" alt="" />
              </div>
            </div>
            <div className="maxh-350 overflow-y">
              <Steps direction="vertical" active={0}>
                {(tracksList ?? []).map((item: Tracks, idx: number) => (
                  <Steps.Item key={idx}>
                    <div className="d-flex-c mb-5">
                      <span className="mb-10">{item?.time}</span>
                      <span className="pr-10 line-height-20">{item.context}</span>
                    </div>
                  </Steps.Item>
                ))}
              </Steps>
            </div>
          </div>
        </div>
      )}
      <div className="m-10 d-flex-r bg-white border-radius-8 p-15">
        <img className="w-25 h-25" src="/pic/icon_receive.png" alt="" />
        <div className="ml-10 d-flex-c">
          <div className="mb-3 line-height-25">{receiverInfo?.address}</div>
          <div className="d-flex-r ai-center text-color-6">
            <span>{receiverInfo?.receiverName}</span>
            <span className="ml-10">{receiverInfo?.receiverPhone}</span>
          </div>
        </div>
      </div>
    </Page>
  );
}
